/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateInventoryRecordItemDto } from '../models/CreateInventoryRecordItemDto';
import type { UpdateInventoryRecordItemDto } from '../models/UpdateInventoryRecordItemDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InventoryRecordItemsService {
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static inventoryRecordItemsControllerCreate(
    requestBody: CreateInventoryRecordItemDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/inventory-record-items',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static inventoryRecordItemsControllerFindAll(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-record-items',
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static inventoryRecordItemsControllerFindOne(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-record-items/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static inventoryRecordItemsControllerUpdate(
    id: string,
    requestBody: UpdateInventoryRecordItemDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/inventory-record-items/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static inventoryRecordItemsControllerRemove(id: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/inventory-record-items/{id}',
      path: {
        id: id,
      },
    });
  }
}
